var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 63,
    viewBox: "0 0 44 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.558002 0L0 62.67L10.938 51.733L0.558002 0Z",
    fill: "#009DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94706 40.4551L23.9941 30.9411L4.93706 16.5541L1.91406 2.11011L27.5421 28.5761L43.7021 18.8701L30.8921 32.0251L41.8791 44.2931L28.3791 34.4391L12.1571 51.0311L9.94706 40.4551Z",
    fill: "#005284"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleLogo);
export default __webpack_public_path__ + "static/media/single_logo.6a9eeb4cbaa40628ceaa2a450c0de3f0.svg";
export { ForwardRef as ReactComponent };